<div
  *ngIf="storeType"
  class="store-type-icon-wrapper"
  title="{{ storeType | storeType | async }}"
  [style.width.px]="size"
  [style.height.px]="size"
>
  <img [src]="'e-commerce-stores/' + (storeType | storeIconName) + '.svg' | assetsPath | async" height="{{ size }}" />
</div>
